// src/components/AdminDashboard/AddCourse.jsx

import React, { useState } from "react";
import TextEditor from "../../components/TextEditor";
import Header from "../../components/Header/Header";
import SideBar from "../../components/SideBar/AdminSideBar";
import { Link } from "react-router-dom";
import axios from "axios";
import { Collapse, Button, Form } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import alertify from "alertifyjs";
import { addCourseSchema } from "../../components/../constant";
import { useForm, Controller } from "react-hook-form";
import { hooks } from "../../studentportal-sdk";

const AddCourse = (props) => {
  const [course, setCourse] = useState({
    title: "",
    description: "",
    startDate: "",
    endDate: "",
    imageUrl: [],
    videoUrl: [],
    audioUrl: [],
    documentUrl: [],
  });

  const [sections, setSections] = useState([{ title: "", description: "" }]);

  const handleSectionChange = (index, e) => {
    const newSections = [...sections];
    newSections[index][e.target.name] = e.target.value;
    setSections(newSections);
    setCourse({ ...course, courseSection: newSections });
  };

  const addSection = () => {
    setSections([...sections, { title: "", description: "" }]);
  };

  const removeSection = (index) => {
    setSections(sections.filter((_, i) => i !== index));
  };

  const toggleSection = (index) => {
    const newSections = [...sections];
    // If you have a state to manage collapse per section, implement here
    // For simplicity, keeping all sections expanded
    setSections(newSections);
  };

  // Handle file uploads for images
  const handleImageChange = async (e) => {
    const files = e.target.files;
    const formData = new FormData();

    // Append the selected files to FormData
    formData.append("file", files[0]); // Handling single file for image
    formData.append("upload_preset", "joqtcy5z"); // Replace with your Cloudinary upload preset

    try {
      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/dbklykh2o/image/upload`,
        formData
      );

      // Get the Cloudinary URL from the response
      const cloudinaryUrl = res.data.secure_url;

      // Update the course state with the Cloudinary URL
      setCourse((prevCourse) => ({
        ...prevCourse,
        imageUrl: [...prevCourse.imageUrl, cloudinaryUrl], // Append the new Cloudinary URL
      }));
    } catch (error) {
      console.error("Error uploading image to Cloudinary:", error);
      alertify.error("Image upload failed. Please try again.");
    }
  };

  // Handle file uploads for documents, videos, audios
  const handleFileUpload = async (e, fileType) => {
    const files = e.target.files;
    const formData = new FormData();

    // Append the selected files to FormData
    formData.append("file", files[0]); // Handling single file; modify for multiple
    formData.append("upload_preset", "yldjhjx9"); // Replace with your Cloudinary upload preset

    try {
      let uploadUrl = "";

      if (fileType === "document") {
        uploadUrl = `https://api.cloudinary.com/v1_1/dt6nxoqmk/document/upload`;
      } else if (fileType === "video") {
        uploadUrl = `https://api.cloudinary.com/v1_1/dt6nxoqmk/video/upload`;
      } else if (fileType === "audio") {
        uploadUrl = `https://api.cloudinary.com/v1_1/dt6nxoqmk/audio/upload`;
      }

      const res = await axios.post(uploadUrl, formData);

      // Get the Cloudinary URL from the response
      const cloudinaryUrl = res.data.secure_url;

      // Update the course state with the Cloudinary URL based on file type
      if (fileType === "document") {
        setCourse((prevCourse) => ({
          ...prevCourse,
          documentUrl: [...prevCourse.documentUrl, cloudinaryUrl],
        }));
      } else if (fileType === "video") {
        setCourse((prevCourse) => ({
          ...prevCourse,
          videoUrl: [...prevCourse.videoUrl, cloudinaryUrl],
        }));
      } else if (fileType === "audio") {
        setCourse((prevCourse) => ({
          ...prevCourse,
          audioUrl: [...prevCourse.audioUrl, cloudinaryUrl],
        }));
      }
    } catch (error) {
      console.error(`Error uploading ${fileType} to Cloudinary:`, error);
      alertify.error(
        `${
          fileType.charAt(0).toUpperCase() + fileType.slice(1)
        } upload failed. Please try again.`
      );
    }
  };

  const convertDescription = (htmlDescription) => {
    return htmlDescription.replace(/<\/?[^>]+(>|$)/g, "");
  };

  const handleEditorChange = (data) => {
    setCourse({
      ...course,
      description: convertDescription(data), // Update the course description with editor data
    });
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addCourseSchema),
  });

  const {
    courseService: {
      action: { addCourse },
    },
  } = props;

  const onSubmit = (data) => {
    if (data) {
      const { videoUrl, imageUrl } = course;
      // Merge form data with course state
      const completeCourseData = {
        ...data,
        imageUrl,
        videoUrl:[data.videoUrl],
        courseSection: sections,
      };
      addCourse(completeCourseData);
      alertify.success("Course has been added!");
      // Optionally, reset the form or redirect
    }
  };

  return (
    <div className="main-wrapper">
      {/* Header */}
      <Header />
      {/* Sidebar */}
      <SideBar />

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="description container-fluid">
          <div className="row">
            <div className="col-xl-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <h3 className="page-title">Add Course</h3>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="card-body">
                    <div className="bank-inner-details">
                      <div className="row">
                        {/* Course Title */}
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>
                              Title<span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="title"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <input
                                  className={`form-control ${
                                    errors?.title ? "error-input" : ""
                                  }`}
                                  type="text"
                                  value={value}
                                  onChange={onChange}
                                  autoComplete="off"
                                />
                              )}
                              defaultValue=""
                            />
                            <small className="text-danger">
                              {errors?.title?.message}
                            </small>
                          </div>
                        </div>
                        {/* Course Image */}
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Course Image</label>
                            <div className="change-photo-btn">
                              <div>
                                <p>Add Image</p>
                              </div>
                              <input
                                name="imageUrl"
                                type="file"
                                className="upload"
                                accept="image/*"
                                onChange={handleImageChange}
                              />
                            </div>
                            {course.imageUrl.length > 0 && (
                              <div className="mt-2">
                                {course.imageUrl.map((url, idx) => (
                                  <img
                                    key={idx}
                                    src={url}
                                    alt={`Cover ${idx + 1}`}
                                    width={100}
                                    className="me-2"
                                  />
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Description */}
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Description</label>
                            <TextEditor onChange={handleEditorChange} />
                            <small className="text-danger">
                              {errors?.description?.message}
                            </small>
                          </div>
                        </div>
                        {/* Start Date */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Start Date</label>
                            <Controller
                              name="startDate"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <input
                                  type="date"
                                  className={`form-control ${
                                    errors?.startDate ? "error-input" : ""
                                  }`}
                                  value={value}
                                  onChange={onChange}
                                />
                              )}
                              defaultValue=""
                            />
                            <small className="text-danger">
                              {errors?.startDate?.message}
                            </small>
                          </div>
                        </div>
                        {/* End Date */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>End Date</label>
                            <Controller
                              name="endDate"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <input
                                  type="date"
                                  className={`form-control ${
                                    errors?.endDate ? "error-input" : ""
                                  }`}
                                  value={value}
                                  onChange={onChange}
                                />
                              )}
                              defaultValue=""
                            />
                            <small className="text-danger">
                              {errors?.endDate?.message}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Course Sections */}
                  <div className="card-body">
                    <div className="form-group">
                      <h3>Course Sections</h3>
                    </div>
                    {sections.map((section, index) => (
                      <div key={index} className="form-group mb-3">
                        <Button
                          variant="link"
                          onClick={() => toggleSection(index)}
                          aria-expanded={true}
                          className="text-decoration-none"
                        >
                          {section.title || `Section ${index + 1}`}
                        </Button>
                        <Collapse in={true}>
                          <div>
                            <Form.Group
                              controlId={`sectionTitle${index}`}
                              className="mb-3"
                            >
                              <label>Section Title</label>
                              <input
                                type="text"
                                name="title"
                                className="form-control"
                                value={section.title}
                                onChange={(e) => handleSectionChange(index, e)}
                                required
                              />
                            </Form.Group>

                            <Form.Group
                              controlId={`sectionDescription${index}`}
                              className="mb-3"
                            >
                              <label>Section Description</label>
                              <textarea
                                name="description"
                                className="form-control"
                                value={section.description}
                                onChange={(e) => handleSectionChange(index, e)}
                                required
                              />
                            </Form.Group>

                            <Button
                              variant="danger"
                              onClick={() => removeSection(index)}
                              className="mt-2"
                            >
                              Remove Section
                            </Button>
                          </div>
                        </Collapse>
                      </div>
                    ))}

                    <Button variant="secondary" onClick={addSection}>
                      Add Another Section
                    </Button>
                  </div>

                  {/* File Uploads for Documents, Videos, Audios */}
                  <div className="card-body">
                    <div className="form-group mb-3">
                      <label>Upload Documents</label>
                      <Controller
                        name="documents"
                        control={control}
                        render={({ field }) => (
                          <input
                            type="file"
                            multiple
                            accept=".pdf,.docx,.pptx,.xlsx"
                            className="form-control"
                            onChange={(e) => handleFileUpload(e, "document")}
                          />
                        )}
                      />
                      {course.documentUrl.length > 0 && (
                        <div className="mt-2">
                          <strong>Uploaded Documents:</strong>
                          <ul>
                            {course.documentUrl.map((url, idx) => (
                              <li key={idx}>
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Document {idx + 1}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    <div className="form-group mb-3">
                      <label>Upload Videos</label>
                      <Controller
                        name="videoUrl"
                        control={control}
                        render={({ field: { value, onChange }  }) => (
                          <input
                            type="text"
                            className={`form-control ${
                              errors?.videoUrl ? "error-input" : ""
                            }`}
                            value={value}
                            onChange={onChange}
                          />
                        )}
                      />
                      {/* {course.videoUrl.length > 0 && (
                        <div className="mt-2">
                          <strong>Uploaded Videos:</strong>
                          <ul>
                            {course.videoUrl.map((url, idx) => (
                              <li key={idx}>
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Video {idx + 1}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )} */}
                    </div>

                    {/* <div className="form-group mb-3">
                      <label>Upload Audios</label>
                      <Controller
                        name="audios"
                        control={control}
                        render={({ field }) => (
                          <input
                            type="file"
                            multiple
                            accept="audio/*"
                            className="form-control"
                            onChange={(e) => handleFileUpload(e, "audio")}
                          />
                        )}
                      />
                      {course.audioUrl.length > 0 && (
                        <div className="mt-2">
                          <strong>Uploaded Audios:</strong>
                          <ul>
                            {course.audioUrl.map((url, idx) => (
                              <li key={idx}>
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Audio {idx + 1}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div> */}
                  </div>

                  {/* Submit Button */}
                  <div className="card-body">
                    <div className="form-group">
                      <Button type="submit" variant="primary" className="me-2">
                        Save Course
                      </Button>
                      <Link to="/admin/courses" className="btn btn-danger">
                        Cancel
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* /Page Wrapper */}
      </div>
      {/* /Main Wrapper */}
    </div>
  );
};
export default (props) => <AddCourse {...hooks.course(props)} />;
